import jsCookie from "js-cookie";

import config from "./config";

const CookieService = {
  prefix: config.cookie.prefix,

  /**
   * @param {string} key
   *
   * @returns {string|undefined}
   */
  get(key) {
    return jsCookie.get(this.__getKey(key));
  },

  /**
   * @param {string} key
   *
   * @returns {string|undefined}
   */
  getWithoutPrefix(key) {
    return jsCookie.get(key);
  },

  /**
   * @param {string} key
   * @param {string} value
   * @param {number} expire
   *
   * @returns {string|undefined}
   */
  set(key, value, expire = 14) {
    return jsCookie.set(this.__getKey(key), value, {
      expires: expire,
      secure: true,
      domain: config.cookie.domain,
      sameSite: "Strict"
    });
  },

  /**
   * @param {string} key
   *
   * @returns {void}
   */
  remove(key) {
    return jsCookie.remove(this.__getKey(key), { domain: config.cookie.domain });
  },

  /**
   * @param {string} key
   *
   * @returns {string}
   */
  __getKey(key) {
    return `${this.prefix}-${key}`;
  }
};

export default CookieService;
